<script setup lang="ts">
import merge from 'lodash-es/merge';

defineOptions({
    name: 'WidgetFavouritesLinksSettings'
});

const { $t } = useLocalization();

const emit = defineEmits<{
    (e: 'update:modelValue', payload: any): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const defaults = ref<any>({
    display: '10'
});

const form = computed<FormType<any>>(() =>
{
    return props.modelValue;
});

const displayOptions = computed((): Option[] =>
{
    return [
        { value: '3', text: $t('[[[3]]]') },
        { value: '5', text: $t('[[[5]]]') },
        { value: '10', text: $t('[[[10]]]') }
    ];
});

const triggetModel = (): void =>
{
    emit('update:modelValue', form.value);
};

watch(() => form.value.settings, (value: any) =>
{
    triggetModel();
}, { deep: true });

onBeforeMount(async (): Promise<void> =>
{
    form.value.settings = merge(defaults.value, form.value.settings);
});
</script>

<template>
    <IdeoFormGroup :label="$t('[[[Liczba wyświetlanych elementów]]]')" :invalid-feedback="form.$errors.first('settings.display')" :state="form.$errors.state('settings.display')">
        <IdeoFormSelect v-model="form.settings.display" :options="displayOptions" />
    </IdeoFormGroup>
</template>
